import axios from 'axios';

export default{
    requestOrders(type, form) {
        if (type == 'put') {
            return axios.put(`${process.env.API_URL}/clean-cloud-orders/${form.id}`, form);
        }
        else if (type == 'post') {
            return axios.post(`${process.env.API_URL}/clean-cloud-orders`, form);
        } else if (type == 'delete') {
            return axios.delete(`${process.env.API_URL}/clean-cloud-orders/${form.id}`);
        }
        else {
            return axios.get(`${process.env.API_URL}/clean-cloud-orders`);
        }
    },
    chargeOrder(data){
        return axios.post(`${process.env.API_URL}/charge-order`, data);
    }
}


// WEBPACK FOOTER //
// ./src/Apis/orders.js